import { FeaturesType } from 'contexts/features';

type FeatureFlagsProps = {
  features?: FeaturesType;
};

/**
 * Renders feature flags as a list of key-value pairs as paragraphs.
 *
 * NOTE: Only renders if the footerFeatures feature flag is enabled.
 *
 * @param features The features to render
 * @returns A list of feature flags as paragraphs
 */
export const FeatureFlags = ({ features }: FeatureFlagsProps) => {
  return ( features && features.footerFeatures === true && (
    <div style={{ position: 'absolute', bottom: 0, left: 0, display: 'flex', justifyContent: 'space-around' }}>
      { Object.entries(features).map(([key, value]) => (
        <p key={key} style={{ fontSize: '12px', margin: '0 1em' }}>{key}: {value}</p>
      ))}
    </div>
  ) );
};